import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { PageHeader } from "../../components/Layout";
import { Link } from "react-router-dom";
import { Plus, BookOpen, ListChecks } from "@phosphor-icons/react";

export default function ExaminerDashboard() {
  const [stats, setStats] = useState(null);
  const [exams, setExams] = useState([]);
  useEffect(() => {
    api.get("/analytics/overview").then((r) => setStats(r.data)).catch(() => {});
    api.get("/exams").then((r) => setExams(r.data));
  }, []);

  return (
    <div>
      <PageHeader
        overline="Examiner workspace"
        title="Question banks & exams"
        subtitle="Build assessments, manage questions, and analyze student performance."
        action={
          <div className="flex gap-2">
            <Link to="/app/questions/new" className="border border-zinc-300 px-4 py-2.5 text-sm font-medium hover:bg-zinc-50 inline-flex items-center gap-2" data-testid="new-question-btn">
              <Plus size={14} /> New question
            </Link>
            <Link to="/app/exams-manage/new" className="bg-zinc-900 text-white px-4 py-2.5 text-sm font-medium hover:bg-zinc-800 inline-flex items-center gap-2" data-testid="new-exam-btn">
              <Plus size={14} /> New exam
            </Link>
          </div>
        }
      />

      <div className="grid grid-cols-2 md:grid-cols-4 border border-zinc-200 mb-10" data-testid="examiner-stats">
        {[
          { label: "Total Questions", value: stats?.total_questions ?? "…" },
          { label: "Total Exams", value: stats?.total_exams ?? "…" },
          { label: "Published", value: stats?.published_exams ?? "…" },
          { label: "Attempts", value: stats?.total_attempts ?? "…" },
        ].map((s, i) => (
          <div key={s.label} className={`p-6 ${i < 3 ? "border-r border-zinc-200" : ""}`}>
            <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-2 font-semibold">{s.label}</div>
            <div className="font-display text-3xl font-bold tabular">{s.value}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-0 border border-zinc-200">
        <Link to="/app/questions" className="p-8 border-r border-zinc-200 hover:bg-zinc-50 group">
          <BookOpen size={28} className="mb-6" />
          <div className="font-display text-xl font-bold mb-2 group-hover:underline">Question Bank →</div>
          <div className="text-sm text-zinc-600">Create, edit, and organize questions by subject and difficulty.</div>
        </Link>
        <Link to="/app/exams-manage" className="p-8 hover:bg-zinc-50 group">
          <ListChecks size={28} className="mb-6" />
          <div className="font-display text-xl font-bold mb-2 group-hover:underline">Exam Builder →</div>
          <div className="text-sm text-zinc-600">Compose exams, configure rules, and publish to students.</div>
        </Link>
      </div>

      {exams.length > 0 && (
        <div className="mt-10">
          <div className="text-[11px] uppercase tracking-[0.25em] text-zinc-500 mb-4 font-semibold">Recent exams</div>
          <div className="border border-zinc-200">
            {exams.slice(0, 5).map((e, i) => (
              <Link key={e.exam_id} to={`/app/exams-manage/${e.exam_id}`} className={`flex items-center justify-between p-5 hover:bg-zinc-50 ${i < 4 ? "border-b border-zinc-200" : ""}`}>
                <div>
                  <div className="font-medium">{e.title}</div>
                  <div className="text-xs text-zinc-500">{e.question_ids?.length || 0} questions · {e.duration_minutes}m</div>
                </div>
                <div className={`text-[10px] uppercase tracking-[0.2em] font-semibold border px-2 py-1 ${e.status === "published" ? "border-green-600 text-green-700 bg-green-50" : "border-zinc-300 text-zinc-600"}`}>
                  {e.status}
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
